/**
 * Provides helper functions for creating and manipuating esri/Graphic
 */
window.GraphicHelper = {
    /**
     * Add a polygon graphic to the layer using a color-filled symbol
     */
    createCircleGraphic(geometry, attributes, symbol, popup) {
        if (!geometry || !geometry.radius || !geometry.center || !symbol) {
            return;
        }

        const _symbol = Object.assign(symbol, { type: 'simple-fill' });
        const _geometry = new this.modules.Circle({
            radius: geometry.radius,
            center: geometry.center,
            geodesic: true
        });
        return this.createGraphic(_geometry, attributes, _symbol, popup);
    },

    /**
     * Add a point graphic to the layer using the given icon URL
     */
    createPictureMarkerSymbol(geometry, attributes, popup, iconUrl, width, height) {
        if (!geometry || !geometry.latitude || !geometry.longitude || !iconUrl) {
            return;
        }

        const symbol = {
            type: 'picture-marker',
            url: iconUrl,
            width: width || '36px',
            height: height || '36px'
        };

        return this.createGraphic(geometry, attributes, symbol, popup);
    },

    /**
     * Create a graphic to the layer using the given geometry and symbol
     * Note:
     * - Set symbol if the graphic will be added to GrapicsLayer. If adding the graphic to FeatureLayer, set the symbol through featureLayer's renderer instead
     * - If the graphic will be added to a GraphicsLayer, the attributes.id property must be set for the graphic to be searchable
     */
    createGraphic(geometry, attributes, symbol, popup) {
        const graphic = new this.modules.Graphic({
            attributes: JSON.parse(JSON.stringify(attributes)) || {}
        });

        this.setGraphicProperties(graphic, geometry, symbol, popup);

        return graphic;
    },

    /**
     * Update a graphic using the given properties
     * Note: If updating geometry/symbol, do NOT update the existing property and send it here.
     * Instead, create a new geometry/symbol object. Otherwise the update will not work
     */
    updateGraphicProperties(graphic, { geometry, attributes, symbol, popup, visibility }) {
        if (!graphic) {
            return;
        }

        this.setGraphicProperties(graphic, geometry, symbol, popup, visibility, attributes);
    },

    setGraphicProperties(graphic, geometry, symbol, popup, visibility, attributes) {
        if (geometry) {
            geometry.type = geometry.type || 'point';
            graphic.geometry = geometry;
        }

        if (symbol) {
            graphic.symbol = symbol;
        }

        if (attributes) {
            // graphic.attributes contains the extra/auto-generated property: OID (object id),
            // which is needed for updatng existing graphics.
            // We will replace the rest of the grapic attributes using the new attributes
            Object.keys(graphic.attributes).forEach(attributeName => {
                if (attributeName !== 'OID') {
                    graphic.attributes[attributeName] = attributes[attributeName];
                }
            });
        }

        if (popup) {
            if (graphic.popupTemplate) {
                graphic.popupTemplate.title = popup.title || graphic.popupTemplate.title;
                graphic.popupTemplate.content = popup.content || graphic.popupTemplate.content;
            } else {
                graphic.popupTemplate = new this.modules.PopupTemplate({
                    title: popup.title || '',
                    content: popup.content || ''
                });
            }
        }

        if (visibility !== undefined && graphic.visible != visibility) {
            graphic.visible = visibility;
        }
    }
};
